// src/app/components/sidemenu/sidemenu.component.ts
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { RolesService } from '../../services/roles.service';

@Component({
  selector: 'app-sidemenu',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TegelModule],
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.css',
})
export class SidemenuComponent {
  private readonly roles = inject(RolesService);
  readonly isAdmUPS$ = this.roles.hasRole$('AdmUPS');
}
